import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from "@angular/material/bottom-sheet";
import { MAT_CHIPS_DEFAULT_OPTIONS } from "@angular/material/chips";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { NguCarouselModule } from "@ngu/carousel";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoggedInGuard } from "./domain/security/loggedin.guard";
import { ResquestInterceptor } from "./domain/security/request.interceptor";
import { getDutchPaginatorIntl } from "./shared/custom-paginator";
import { SharedModule } from "./shared/shared.module";
import { ApplicationinsightsAngularpluginErrorService } from "@microsoft/applicationinsights-angularplugin-js";

registerLocaleData(localePt);
@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		SharedModule,
		HttpClientModule,
		NguCarouselModule
	],
	providers: [
		LoggedInGuard,
		{ provide: LOCALE_ID, useValue: "pt-BR" },
		{ provide: DEFAULT_CURRENCY_CODE, useValue: "BRL" },
		{ provide: HTTP_INTERCEPTORS, useClass: ResquestInterceptor, multi: true },
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, horizontalPosition: "end" } },
		{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
		{ provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
		{ provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
		{ provide: MAT_CHIPS_DEFAULT_OPTIONS, useValue: { separatorKeyCodes: [ENTER, COMMA] } },
		{
			provide: "UrlRedirectResolver",
			useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
				const urlFront = (route.data as any).urlFront;

				if (window.location.origin !== urlFront) window.location.href = (route.data as any).urlFront;
			}
		},
		{ provide: ErrorHandler, useClass: ApplicationinsightsAngularpluginErrorService }
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
